
import Axios from 'axios';
Axios.defaults.withCredentials = true; // enable axios post cookie, default false
import {env} from '../../../env.js'
const client = Axios.create({
    baseURL: env.admin,
    json: true
});

export default client;

